module.exports = __webpack_public_path__ + "static/img/success@3x.a8eac9d7.png";